import React from "react"
import classNames from "classnames"
import { separator } from "./styles.module.scss"

const Separator = () => <hr className={classNames(separator)} />

export default Separator
